<ngx-charts-chart [view]="[width, extendedHeight]"
                  [showLegend]="false"
                  [legendOptions]="legendOptions"
                  [activeEntries]="activeEntries"
                  [animations]="animations"
                  (legendLabelActivate)="onActivate($event, undefined!, true)"
                  (legendLabelDeactivate)="onDeactivate($event, undefined!, true)"
                  (legendLabelClick)="onClick($event)">
    <svg:g [attr.transform]="transform" class="bar-chart chart">
        <svg:g ngx-charts-grid-panel-series
               [xScale]="groupScale"
               [yScale]="valueScale"
               [data]="results"
               [dims]="dims"
               [orient]="barOrientation.Vertical"></svg:g>
        @if (xAxis) {
        <svg:g ngx-charts-x-axis
               [xScale]="groupScale"
               [dims]="dims"
               [showLabel]="showXAxisLabel"
               [labelText]="xAxisLabel"
               [trimTicks]="trimXAxisTicks"
               [rotateTicks]="rotateXAxisTicks"
               [maxTickLength]="maxXAxisTickLength"
               [tickFormatting]="xAxisTickFormatting"
               [ticks]="xAxisTicks"
               [xAxisOffset]="dataLabelMaxHeight.negative"
               (dimensionsChanged)="updateXAxisHeight($event)"></svg:g>
        }
        @if (yAxis) {
        <svg:g ngx-charts-y-axis
               [yScale]="valueScale"
               [dims]="dims"
               [showGridLines]="showGridLines"
               [showLabel]="showYAxisLabel"
               [labelText]="yAxisLabel"
               [trimTicks]="trimYAxisTicks"
               [maxTickLength]="maxYAxisTickLength"
               [tickFormatting]="yAxisFormat"
               [ticks]="yAxisTicks"
               (dimensionsChanged)="updateYAxisWidth($event)"></svg:g>
        }
        @if (!isSSR) {
        <svg:g>
            @for (group of results; track trackBy(index, group); let index = $index) {
            <svg:g kilowant-charts-series-vertical-home-accept-offer
                   [attr.transform]="groupTransform(group)"
                   [activeEntries]="activeEntries"
                   [xScale]="innerScale"
                   [yScale]="valueScale"
                   [colors]="colorHelper"
                   [series]="getSeries(group)"
                   [dims]="dims"
                   [gradient]="gradient"
                   [tooltipDisabled]="tooltipDisabled"
                   [tooltipTemplate]="tooltipTemplate"
                   [showDataLabel]="showDataLabel"
                   [dataLabelFormatting]="dataLabelFormatting"
                   [seriesName]="group.name"
                   [roundEdges]="roundEdges"
                   [animations]="animations"
                   [noBarWhenZero]="noBarWhenZero"
                   (select)="onClick($event, group)"
                   (activate)="onActivate($event, group)"
                   (deactivate)="onDeactivate($event, group)"
                   (dataLabelHeightChanged)="onDataLabelMaxHeightChanged($event, index)" />
            }
        </svg:g>

        @if (getActivePeaksPolylinePoints(); as polylinePoints) {
        <svg:polyline [attr.points]="polylinePoints"
                      fill="none"
                      [attr.stroke]="KilowantColor"
                      stroke-width="4"
                      stroke-dasharray="10,10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style="pointer-events: none;" />
        }
        }
        <filter filterUnits="userSpaceOnUse" id="gblur">
            <feGaussianBlur in="src" stdDeviation="0" result="noblur"></feGaussianBlur>
            <feColorMatrix in="src" result="white" type="matrix"
                           values="0 0 0 0 1
                             0 0 0 0 1
                             0 0 0 0 1
                             0 0 0 1 0" />
            <feGaussianBlur stdDeviation="1" in="white" result="blur1"></feGaussianBlur>
            <feGaussianBlur stdDeviation="2" in="white" result="blur2"></feGaussianBlur>
            <feGaussianBlur stdDeviation="3" in="white" result="blur3"></feGaussianBlur>
            <feGaussianBlur stdDeviation="4" in="white" result="blur4"></feGaussianBlur>
            <feGaussianBlur stdDeviation="5" in="white" result="blur5"></feGaussianBlur>
            <feMerge>
                <feMergeNode in="blur1"></feMergeNode>
                <feMergeNode in="blur2"></feMergeNode>
                <feMergeNode in="blur3"></feMergeNode>
                <feMergeNode in="blur4"></feMergeNode>
                <feMergeNode in="blur5"></feMergeNode>
                <feMergeNode in="noblur"></feMergeNode>
            </feMerge>
        </filter>

        <text style="font-size: 14px; font-weight: bold;cursor: pointer;" (click)="goToVal()" filter="url(#gblur)" [attr.id]="'price-1-text'+prefix"></text>
        <line stroke-width="4" [attr.id]="'price-1-line'+prefix" [class]="(shadow)?'chat-info-shadow':''" />

        <text style="font-size: 14px; font-weight: bold;cursor: pointer;" (click)="goToVal()" filter="url(#gblur)" [attr.id]="'price-2-text'+prefix"></text>
        <line stroke-width="4" [attr.id]="'price-2-line'+prefix" />

        <text style="font-size: 14px; font-weight: bold;cursor: pointer;" (click)="goToVal()" filter="url(#gblur)" [attr.id]="'price-3-text'+prefix"></text>
        <line stroke-width="4" [attr.id]="'price-3-line'+prefix" />

        <text style="font-size: 14px; font-weight: bold;cursor: pointer;" (click)="goToVal()" filter="url(#gblur)" [attr.id]="'price-4-text'+prefix"></text>
        <line stroke-width="4" [attr.id]="'price-4-line'+prefix" />

        <text style="font-size: 14px; font-weight: bold;" [attr.id]="'price-info'+prefix" filter="url(#gblur)"></text>

        <polygon style="fill:#58504e;stroke:none;cursor: pointer;" [class]="(shadow)?'chat-info-shadow':''" (click)="goNowSlide()" filter="url(#gblur)" [attr.id]="'myContractArrow'+prefix" />
        <text style="color: #58504e; text-decoration: underline;font-size: 16px;font-weight: bold;cursor: pointer;" (click)="goNowSlide()" filter="url(#gblur)" [attr.id]="'myContractText'+prefix"></text>

        <polygon style="stroke:none;cursor: pointer;" (click)="goNextSlide()" [attr.id]="'nextArrow'+prefix" />
        <text style="text-decoration: underline; font-size: 16px; font-weight: bold; cursor: pointer;" filter="url(#gblur)" [class]="(shadow)?'chat-info-shadow':''" (click)="goNextSlide()" [attr.id]="'nextText'+prefix"></text>

        <polygon [attr.id]="'chatout'+prefix" [class]="(shadow)?'chat-info-shadow':''" />

        <line stroke-width="2" stroke-dasharray="10,5" [attr.id]="'average-line'+prefix" />
    </svg:g>
</ngx-charts-chart>
            @if (datasetSelector) {
<div class="checkbox-selector mt-10">
    <label [class]="(selectedDatasets.includes(1))?'checked '+((selectedDatasets.length>1)?'input-with-x white':''):''" [attr.style]="((selectedDatasets.includes(1))?'color: #fff;':'')+'font-size: 12px; border-color:'+RIColor+((selectedDatasets.includes(1))?('; background-color: '+RIColor):'')"><input type="checkbox" name="termFrom" (change)="datasetChangedEmitter.next(1)" value="">vs {{utilityName}}</label>
    <label [class]="(selectedDatasets.includes(2))?'checked '+((selectedDatasets.length>1)?'input-with-x white':''):''" [attr.style]="((selectedDatasets.includes(2))?'color: #fff;':'')+'font-size: 12px; border-color:'+CommunityColor+((selectedDatasets.includes(2))?('; background-color: '+CommunityColor):'')"><input type="checkbox" name="termFrom" (change)="datasetChangedEmitter.next(2)" value="">vs {{communityName}}</label>
</div>
            }

            @if (legend) {
<div class="chart-legend">
    <ngx-charts-legend [data]="legendData"
                       [colors]="colorHelper">
    </ngx-charts-legend>
    @if (showKilowantLine) {
      <div style="font-size: 12px; line-height: 15px; color: #58504e; margin-top: 5px; padding-right: 10px;"><span [attr.style]="'display: inline-block; height: 15px; width: 15px; margin-right: 5px; background-color: '+KilowantColor+'; border-radius: 3px;'"></span><span style="vertical-align: top;">kilowant Suggested Price Plan Package</span></div>
    }
    <div>
        @if (containsForecasted(utilityName) && utilityWarningDate!=null && utilityWarningDate!='') {
        <div class="utility-chart-info" [style.color]="RIColor"><span class="asterik">{{repeater("*", asterikVals.indexOf(utilityName)+1)}}</span>{{utilityNameForWarning}} rate beyond {{utilityWarningDate}} is estimated and subject to adjustment</div>
        }
        @if (containsForecasted(communityName) && communityWarningDate!=null && communityWarningDate!='') {
        <div class="utility-chart-info" [style.color]="CommunityColor"><span class="asterik">{{repeater("*", asterikVals.indexOf(communityName)+1)}}</span>{{communityNameForWarning}} supply rates beyond {{communityWarningDate}} are estimates and subject to change with market conditions</div>
        }
        @if (!hideRenewable) {
        <div class="utility-chart-info c-e-source">
            @if (val.length==0) {
            <span>All offers meet</span>
            }@if (val.length>0) {
            <span>Price plan meets</span>
            } the RI Renewable Portfolio Standard
        </div>
        }
    </div>
</div>
            }